export function sessionFlash(message, success, timeout, redirect){
	if(timeout === undefined){
		timeout = 3000;
	}
	let flashModal = $('#flashModal');
	flashModal.find('.modal-body').removeClass('success danger');
	flashModal.find('.modal-body').html('');
	flashModal.find('.modal-body').prepend('<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><p class="modal-title" id="flashModalTitle"></p>');
	flashModal.find('.modal-body').addClass(success ? 'success' : 'danger');
	flashModal.find('.modal-title').html(success ? 'Success' : 'Sorry');
	flashModal.find('.modal-body').append('<p>' + message + '</p>');
	flashModal.modal('show');

	if(timeout !== null && timeout !== 0){
		if(redirect !== undefined){
			setTimeout(function(){
				window.location.href = redirect;
			}, timeout);
			let counter = parseInt(JSON.parse(JSON.stringify(timeout)));
			flashModal.find('.modal-body').append('<p class="small"><strong>We will redirect your page in <span data-redirect-countdown="">' + (counter / 1000) + '</span></strong></p><p><a href="' + redirect + '" class="btn btn-primary">Redirect now</a></p>');

			setInterval(function(){
				counter -= 1000;
				if(counter >= 0){
					$('[data-redirect-countdown]').text((counter/1000));
				}
			}, 1000);
		}else{
			setTimeout(function(){
				flashModal.modal('hide');
			}, timeout);
		}
	}
}
